import SelectShippingProviderView from './SelectShippingProviderView';

export default SelectShippingProviderView;
